import { Link } from "@inertiajs/react"
import { cn } from "@/lib/utils"
import { tabsListVariants, tabsTriggerVariants } from "@/components/ui/Tabs"
import { useNavSections } from "./useNavSections"

// The current page's Menu section as tabs, in the page title row, so moving
// between pages of one section (Purchase Plan ↔ Incoming / PO) is one click.
// Only sections marked pageTabs; nothing on pages outside them.
export default function PageTabs() {
  const { sections, active } = useNavSections()
  const section = sections.find((s) => s.pageTabs && s.links.some((l) => l.href === active))
  if (!section || section.links.length < 2) return null

  return (
    <nav aria-label={section.heading} className={tabsListVariants({ variant: "segmented" })}>
      {section.links.map((l) => (
        <Link
          key={l.href}
          href={l.href}
          aria-current={l.href === active ? "page" : undefined}
          data-state={l.href === active ? "active" : "inactive"}
          className={cn(tabsTriggerVariants({ variant: "segmented" }))}
        >
          {l.label}
        </Link>
      ))}
    </nav>
  )
}
